import { Camera } from 'phosphor-react-native';
import React from 'react';
import { CardBasicItem } from '../../CardBasicItem';
import { CardContainer } from '../../CardContainer';
import { colors } from '../../../theme/theme';

interface IAddCard {
  onPress: () => void;
  title: string;
  disabled?: boolean;
}

export const AddCard = ({ onPress, title }: IAddCard) => (
  <CardContainer flexDirection={'row'}>
    <CardBasicItem
      titleColor={'yankeesBlue'}
      title={title}
      titleWeight="regular"
      titleVariant={'body'}
      rightIcon={<Camera color={colors.green} />}
      withCardContainer={false}
      onPress={onPress}
    />
  </CardContainer>
);
